var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { readableColor as textColorContrast } from 'polished';
import breakpoint from 'Styles/breakpoints';
import { convertColorToThemeHexCode } from 'Styles/colors.util';
import { Container, Content } from '../ContentSystem/components/OverlayModal/OverlayModal.styled';
import OverlayModal from '../ContentSystem/components/OverlayModal/OverlayModal';
import ContentfulTextBlockOriginal from '../ContentfulTextBlock/ContentfulTextBlock';
export var Modal = styled(OverlayModal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", " {\n    ", " {\n      min-height: 85%;\n    }\n  }\n  ", " {\n    height: 100%;\n  }\n"], ["\n  ", " {\n    ", " {\n      min-height: 85%;\n    }\n  }\n  ", " {\n    height: 100%;\n  }\n"])), Container, breakpoint('medium'), Content);
export var ContentfulTextBlock = styled(ContentfulTextBlockOriginal)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  height: 100%;\n"], ["\n  color: ", ";\n  height: 100%;\n"])), function (props) {
    return textColorContrast(convertColorToThemeHexCode(props.backgroundColor), convertColorToThemeHexCode('white'), convertColorToThemeHexCode('black'));
});
export default {};
var templateObject_1, templateObject_2;
